import { Map, fromJS } from 'immutable';

import {
  filtersFetchedType,
  updateGroupByIdType,
  updateFilterByIdType,
  addFilterGroupsByIdType,
} from '../ListOfFiltersConstants';


import {
  normalizeItems,
  findByIdForImmutableCollectionFn,
} from '@Utils';

import initialState from './initialState';



export function generalFiltersReducer (state = initialState, action) {
  switch (action.type) {

    case filtersFetchedType: {
      const { key, data } = action.payload;

      const result = normalizeItems(data);

      return state.set(
        key,
        fromJS({
          ids: result.ids,
          items: result.items,
        }),
      );
    }

    case updateFilterByIdType: {
      const { key, filterId, data } = action.payload;

      return state.updateIn([key, 'items', filterId], (filter) => {
        return filter.merge(fromJS(data));
      });
    }

    case addFilterGroupsByIdType: {
      const {
        key,
        index,
        groups,
        hitCount,
        filterId,
        groupCount,
        thesaurusGroups,
        thesaurusRootId,
      } = action.payload;

      return state.updateIn([key, 'items', filterId], (filter) => {
        const currentHitCount = filter.get('hitCount');
        const currentThesaurusRootId = filter.get('thesaurusRootId');
        const currentIndex = filter.get('index');

        const currentGroups = filter.get('groups');
        const currentGroupCount = filter.get('groupCount');
        const nextGroups = currentGroups.concat(fromJS(groups));

        const thesaurusGroupsExtension = thesaurusGroups ?
          {
            thesaurusGroups: normalizeItems(thesaurusGroups)
          } :
          {};

        return filter.merge(fromJS({
          index: currentIndex || index,
          hitCount: currentHitCount || hitCount,
          thesaurusRootId: currentThesaurusRootId || thesaurusRootId,
          groups: nextGroups,
          groupCount: groupCount || currentGroupCount,
          ...thesaurusGroupsExtension,
        }));
      });
    }

    case updateGroupByIdType: {
      const { key, filterId, groupId, data } = action.payload;

      return state.updateIn([key, 'items', filterId], (filter) => {

        const currentGroups = filter.get('groups');
        const currentGroupIndex = currentGroups.findIndex(findByIdForImmutableCollectionFn(groupId));
        const currentGroup = currentGroups.get(currentGroupIndex);
        const nextGroup = currentGroup.merge(fromJS(data));
        const nextGroups = currentGroups.set(currentGroupIndex, nextGroup);

        return filter.set('groups', nextGroups);

      });
    }

    default: {
      return state;
    }
  }
}


